import React from 'react';
//import {authRoles} from '../../auth';

export const RequestRRHHConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    //auth : [authRoles.master, authRoles.admin],
    routes  : [
        {
            path     : '/RequestRRHH',
            component: React.lazy(() => import('./RequestRRHH'))
        }
    ]
};